
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import UmbracoApiService from "@/services/UmbracoApiService";
import MiInversionModel from "@/models/MiInversion/MiInversionModel";
import BarChart from "../Charts/BarChart.vue";
import LineChart from "../Charts/LineChart.vue";
import DoughnutChart from "../Charts/DoughnutChart.vue";

@Component({
  components: {
    BarChart,
    LineChart,
    DoughnutChart,
  },
})
export default class MiInversionResult extends Vue {
  @Prop() rentaAcumulada: any;
  @Prop() rentabilidad: any;

  public tiposDeFondos: Array<Option<FundType>> = [];
  public tipoFondo: FundType = new FundType();
  public wsdlService: WsdlService = new WsdlService();
  public userId: string = this.$store.state.user.cedula;
  public isLoading: boolean = false;
  public displayChart: boolean = false;
  public displayDoughnut: boolean = false;
  public myStyles: any = {
    height: "300px",
    width: "100%",
  };
  public totalAportes: number = 0;
  public totalRentabilidad: number = 0;
  public totalBalanceF: number = 0;
  public totalRendimiento: number = 0;
  //table
  public items: any = [];
  //charts
  public dataCollection: any = {};
  public dataCollectionLine: any = {};
  public Lineoptions: any = {};
  public dataCollectionDoughnut: any = {};
  public doughnutOptions: any = {};

  constructor() {
    super();
  }

  public umbracoService = new UmbracoApiService();
  public miInversion = new MiInversionModel();

  async mounted() {
    try {
      await this.getData();
    } catch (e) {
      console.error("getData falló:", e);
    }

    try {
      await this.getDropdownData();
    } catch (e) {
      console.error("getDropdownData falló:", e);
    }

    try {
      this.fillTable();
    } catch (e) {
      console.error("fillTable falló:", e);
    }

    try {
      this.getTotals();
    } catch (e) {
      console.error("getTotals falló:", e);
    }

    try {
      this.getBarChart();
    } catch (e) {
      console.error("getBarChart falló:", e);
    }

    try {
      this.getLineChart();
    } catch (e) {
      console.error("getLineChart falló:", e);
    }

    try {
      this.getAportes();
    } catch (e) {
      console.error("getAportes falló:", e);
    }
  }

  public getAportes() {
    let labels = [];
    let data = [];
    let totalAmount = Number(this.rentaAcumulada[0].saldototal);
    this.rentaAcumulada.forEach((element) => {
      labels.push(element.tipo);
      data.push((Number(element.valor) * 100) / totalAmount);
    });
    this.dataCollectionDoughnut = {
      labels: labels,
      datasets: [
        {
          title: "Composición de Mi Inversión",
          label: labels,
          data: data,
          backgroundColor: ["#F4C059", "#F7A93C", "#28346D", "#265DB2"],
        },
      ],
    };

    this.doughnutOptions = {
      plugins: {
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || "";

              if (label) {
                label += ": ";
              }
              if (context.parsed.y !== null) {
                label += new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(context.parsed.y);
              }
              return label;
            },
          },
        },
      },
    };

    this.displayDoughnut = true;
  }
  public getLineChart() {
    let labels = [""];
    let data = [NaN];
    let max = this.rentabilidad.length > 14 ? 14 : this.rentabilidad.length - 1;
    for (let index = 0; index < max; index++) {
      const element = this.rentabilidad[index];
      labels.push(element.anio);
      element.rendimiento.replace("%", "");
      let rendimiento = 0;
      if (element.rendimiento.includes("-")) {
        rendimiento = Number(element.rendimiento.replace("-", "0")) * 100;
      } else {
        rendimiento = Number("0" + element.rendimiento) * 100;
      }
      if (rendimiento < 1) rendimiento = NaN;
      data.push(Number(rendimiento.toFixed(2)));
    }
    data.push(NaN);
    labels.push("");

    this.dataCollectionLine = {
      labels: labels,
      datasets: [
        {
          label: "Rendimiento de Mi Inversión",
          backgroundColor: "#F7A93C",
          data: data,
          showLine: true,
          fill: false,
          borderColor: "#F7A93C",
          spanGaps: true,
        },
      ],
    };

    this.Lineoptions = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          left: 100,
          right: 100,
        },
      },
      scales: {
        yAxes: [
          {
            display: true,
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    };
  }
  public getBarChart() {
    let labels = [];
    let data = [];
    this.rentabilidad.forEach((element) => {
      labels.push(element.anio);
      data.push(Number(Number(element.balancefinal).toFixed(2)));
    });
    this.dataCollection = {
      labels: labels,
      datasets: [
        {
          label: "Crecimiento de Mi Inversión",
          backgroundColor: "#337ab7",
          data: data,
        },
      ],
    };
    this.displayChart = true;
  }
  public getTotals() {
    let tRendimiento = 0;
    this.rentabilidad.forEach((element) => {
      if (element.aportes.includes(",")) {
        this.totalAportes += Number(element.aportes.replace(",", ""));
      } else {
        this.totalAportes += Number(element.aportes);
      }

      if (element.aportes.includes(",")) {
        this.totalRentabilidad += Number(element.rentabilidad.replace(",", ""));
      } else {
        this.totalRentabilidad += Number(element.rentabilidad);
      }

      element.rendimiento.replace("%", "");
      let rendimiento = 0;
      if (element.rendimiento.includes("-")) {
        rendimiento = Number(element.rendimiento.replace("-", "0"));
        if (rendimiento > 0) tRendimiento++;
        this.totalRendimiento += rendimiento;
      } else {
        rendimiento = Number("0" + element.rendimiento);
        if (rendimiento > 0) tRendimiento++;
        this.totalRendimiento += rendimiento;
      }
    });
    this.totalBalanceF = Number(
      this.rentabilidad[this.rentabilidad.length - 1].balancefinal.replace(
        ",",
        ""
      )
    );
    this.totalRendimiento = (this.totalRendimiento * 100) / tRendimiento;
  }
  public fillTable() {
    this.items = this.rentabilidad.map((x: any) => ({
      año: x.anio,
      balance_inicial: Number(
        Number(x.balanceinicial).toFixed(2)
      ).toLocaleString(undefined, { minimumFractionDigits: 2 }),
      aportes: Number(Number(x.aportes).toFixed(2)).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      }),
      rentabilidad: Number(Number(x.rentabilidad).toFixed(2)).toLocaleString(
        undefined,
        { minimumFractionDigits: 2 }
      ),
      balance_final: Number(Number(x.balancefinal).toFixed(2)).toLocaleString(
        undefined,
        { minimumFractionDigits: 2 }
      ),
      rendimiento: this.formatRendimiento(x.rendimiento),
    }));
  }
  public formatRendimiento(rendimiento: string): string {
    if (!rendimiento) return "0%";
    if (rendimiento.includes("-")) {
      let result = (Number(rendimiento.replace("-", "0")) * 100).toFixed(2);
      return (
        Number(result).toLocaleString(undefined, { minimumFractionDigits: 2 }) +
        "%"
      );
    } else {
      let rend = (Number("0" + rendimiento) * 100).toFixed(2);
      return (
        Number(rend).toLocaleString(undefined, { minimumFractionDigits: 2 }) +
        "%"
      );
    }
  }
  async getDropdownData() {
    this.wsdlService
      .getTipoDeFondos(this.userId, "")
      .then((response: AxiosResponse<FundTypeObj>) => {
        let option = new Option<FundType>();
        option.value = response.data.tipofondos;
        option.text = response.data.tipofondos.valor;
        option.disabled = false;
        this.tiposDeFondos.push(option);
        this.tipoFondo = option.value;
      });
  }
  async getData() {
    this.miInversion = await this.umbracoService.getMiInversion();
  }
  public returnForm() {
    this.$emit("returnForm");
  }
  public updateUser() {
    this.$router.push("actualizacion-de-datos");
  }
  returnHome() {
    window.location.href = GlobalConfig.PORTAL_BASE_URL;
  }
}
